import { useMutation } from '@tanstack/react-query'

import { TagModel } from '@/domain/model/customer'

import { updateTagClientById } from './services/updateTagClientById'
import { invalidateLoadTagsClient } from './useLoadTagsClient'

export const useUpdateTagClientById = () => {
  const mutation = useMutation({
    mutationFn: async (data?: Partial<TagModel>) =>
      await updateTagClientById(data),
    onSuccess: async () => await invalidateLoadTagsClient(),
  })

  const updateTagClientByIdReq = async (data?: Partial<TagModel>) => {
    return mutation.mutateAsync(data)
  }

  return {
    updateTagClientById: updateTagClientByIdReq,
    ...mutation,
  }
}
